import fetch from 'isomorphic-fetch';
import { API } from '../../config';
import cookie from 'js-cookie';
// import Router from 'next/router';
import { useHistory } from 'react-router-dom';

// WHEN TOKEN EXPIRES USER WILL REDIRECT TO LOGIN PAGES
export const handleResponse = (response) => {
  if (response.status === 401) {
    logout(() => {
      useHistory.push({
        pathname: '/auth',
        query: {
          message: 'Your session is expired. Please signin',
        },
      });
    });
  }
};

export const preSignup = async (user) => {
  try {
    const response = await fetch(`${API}/pre-register`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

export const signup = async (user) => {
  try {
    const response = await fetch(`${API}/register`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

export const signin = async (user) => {
  try {
    const response = await fetch(`${API}/login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

// COOKIES
export const setCookie = (key, value) => {
  if (process.browser) {
    cookie.set(key, value, {
      expires: 1,
    });
  }
};

export const removeCookie = (key) => {
  if (process.browser) {
    cookie.remove(key, {
      expires: 1,
    });
  }
};

export const getCookie = (key) => {
  if (process.browser) {
    return cookie.get(key);
  }
};

// LOCALSTORAGE
export const setLocalStorage = (key, value) => {
  if (process.browser) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
export const removeLocalStorage = (key) => {
  if (process.browser) {
    localStorage.removeItem(key);
  }
};

// AUTHENTICATE USER BY cookie and localstorage
export const authenticate = (data, next) => {
  setCookie('token', data.token);
  setLocalStorage('user', data.user);
  next(); //will execution, in this purpose push to homepage
};

//  Check user already exist ?
export const isAuth = () => {
  if (process.browser) {
    const cookieChecked = getCookie('token');
    if (cookieChecked) {
      if (localStorage.getItem('user')) {
        return JSON.parse(localStorage.getItem('user'));
      } else {
        return false;
      }
    }
  }
};

// LOGOUT
export const logout = async (next) => {
  removeCookie('token');
  removeLocalStorage('user');
  next();

  try {
    const response = await fetch(`${API}/logout`, {
      method: 'GET',
    });
    console.log(response.message);
  } catch (error) {
    console.log(error);
  }
};

// UPDATE USER INFORMATION IN LOCALSTORE AFTER UPDATED PROFILE
export const updateUserLocalStorage = (user, next) => {
  if (process.browser) {
    if (localStorage.getItem('user')) {
      let auth = JSON.parse(localStorage.getItem('user'));
      auth = user;
      localStorage.setItem('user', JSON.stringify(auth));
      next();
    }
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${API}/forgot-password`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(email),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

export const resetPassword = async (resetInfo) => {
  try {
    const response = await fetch(`${API}/reset-password`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(resetInfo),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
